import { render, staticRenderFns } from "./QuizPlayer.vue?vue&type=template&id=c4200144&scoped=true"
import script from "./QuizPlayer.vue?vue&type=script&lang=js"
export * from "./QuizPlayer.vue?vue&type=script&lang=js"
import style0 from "./QuizPlayer.vue?vue&type=style&index=0&id=c4200144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4200144",
  null
  
)

export default component.exports